import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";

function VideoDownload() {

  // List of all videos
  const videos = [
    "/videos/offline/video_01a_1.mp4",
    "/videos/02.mp4",
    "/videos/offline/video_03_1.mp4",
    "/videos/offline/video_04_1.mp4",
    "/videos/offline/video_05_1.mp4",
    "/videos/offline/video_06_1.mp4",
    "/videos/offline/video_07_1.mp4",
    "/videos/08-successful-close.mp4",
    "/videos/08-unsuccessful-close.mp4",
    "/videos/02-news-reporter-successful.mp4",
    "/videos/02-news-reporter-unsuccessful.mp4"
  ];

  const [cacheStatus, setCacheStatus] = useState({});

  // Helper: check if a video is cached
  async function isVideoCached(url) {
    if (!("caches" in window)) return false;
    try {
      const cache = await caches.open("cer-video-cache-v1");
      const match = await cache.match(url);
      return !!match;
    } catch (err) {
      console.warn("Cache check failed for", url, err);
      return false;
    }
  }

  // On mount: check all videos
  useEffect(() => {
    async function checkAll() {
      const results = {};
      for (const url of videos) {
        results[url] = await isVideoCached(url);
      }
      setCacheStatus(results);
    }
    checkAll();
  }, []);

  // When user plays a video, mark as "caching…" then re-check after delay
  function handlePlay(url) {
    setCacheStatus(prev => ({ ...prev, [url]: "caching" }));

    setTimeout(async () => {
      const cached = await isVideoCached(url);
      setCacheStatus(prev => ({ ...prev, [url]: cached }));
    }, 3000);
  }

  // Cache ALL videos at once
  async function cacheAllVideos() {
    if (!navigator.serviceWorker?.controller) {
      alert("Service worker not ready yet.");
      return;
    }

    // Mark all as caching
    const newStatus = {};
    videos.forEach(url => newStatus[url] = "caching");
    setCacheStatus(prev => ({ ...prev, ...newStatus }));

    // Ask SW to cache each video (same mechanism as playing)
    videos.forEach(url => {
      navigator.serviceWorker.controller.postMessage({
        type: "CACHE_VIDEO",
        url
      });
    });

    // Re-check after a delay
    setTimeout(async () => {
      const results = {};
      for (const url of videos) {
        results[url] = await isVideoCached(url);
      }
      setCacheStatus(prev => ({ ...prev, ...results }));
    }, 4000);
  }

  // Render status label
  function renderStatus(url) {
    const status = cacheStatus[url];

    if (status === true) {
      return <span style={{ color: "#129B29", fontWeight: "bold" }}>Cached ✓</span>;
    }
    if (status === "caching") {
      return <span style={{ color: "orange", fontWeight: "bold" }}>Caching…</span>;
    }
    return <span style={{ color: "red", fontWeight: "bold" }}>Not cached</span>;
  }

  return (
    <div id="app-admin" className="page physical">

      <header className="container-fluid">
        <div className="row">
          <div className="col-12"></div>
        </div>
      </header>

      <main className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div id="box-wrapper-admin" className="text-center">
              <div className="admin-body mt-auto">
                <h1>Cache Videos</h1>
                <p>Play each video to cache it for offline viewing, or use the button below to cache all videos at once.</p>

                <button className="btn" onClick={cacheAllVideos} style={{ marginBottom: "20px" }}>
                  Cache All Videos
                </button>

                <table style={{ margin: "0 auto" }}>
                  <tbody>
                    {Array.from({ length: Math.ceil(videos.length / 6) }).map((_, rowIndex) => (
                      <tr key={rowIndex}>
{videos.slice(rowIndex * 6, rowIndex * 6 + 6).map(url => {
  const subtitleUrl = url.replace(".mp4", ".vtt");

  return (
    <td key={url} style={{ padding: "8px" }}>
      <video
        className="video-thumb"
        controls
        onPlay={() => handlePlay(url)}
        width="200"
      >
        <source src={url} type="video/mp4" />
        <track
          src={subtitleUrl}
          kind="subtitles"
          srcLang="en"
          label="English"
          default
        />
        Your browser does not support the video tag.
      </video>

      <div style={{ marginTop: "6px" }}>
        {renderStatus(url)}
      </div>
    </td>
  );
})}
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>

              <div className="admin-footer">
                <Link to="/app-admin" className="btn">Logout</Link>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="container-fluid">
        <div className="row">
          <div className="col-12"></div>
        </div>
      </footer>

    </div>
  );
}

export default VideoDownload;
